import useFacebookFeedback from '~/shared/components/facebook-feedback/use-facebook-feedback';

type FacebookFeedbackPropsType = {
  alias: string;
};

const FacebookFeedback = ({ alias }: FacebookFeedbackPropsType) => {
  useFacebookFeedback();

  return (
    <div
      className="fb-messages"
      data-order-by="reverse_time"
      data-width="100%"
      data-href={`http://prana-club.com/posts/${alias}`}
      data-numposts="10"
    />
  );
};

export default FacebookFeedback;
